import ProductName from './ProductName'

export default ProductName
